export default {
  settings: {},
};



// WEBPACK FOOTER //
// ./src/store/modules/settings/state.js